import { SxProps } from '@mui/material'

interface DropdownStyles {
  wrapper: SxProps
  popover: SxProps
  content: SxProps
}

export const dropdownStyles: DropdownStyles = {
  wrapper: {},
  popover: {
    my: '5px !important', // why !important? because Popper margin 0 as inline styles so there is no way to override it
  },
  content: {
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: { xs: '350px', md: '500px' },
  },
}
